var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NbButton',{attrs:{"type":"button","variant":"secondary"},on:{"click":_vm.close}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.$t("close"))+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }